import { response } from "app/helpers/commonInterface";
import {
  GET_TASK_TIME_REPORT_LIST_FAILURE,
  GET_TASK_TIME_REPORT_LIST_REQUEST,
  GET_TASK_TIME_REPORT_LIST_SUCCESS,
} from "../actionTypes";
import { TaskTimeEntry } from "./taskDataInterface";

export interface taskTimeReportListState {
  loading: boolean;
  taskTimeDetails: response<TaskTimeEntry[]>;
  error: string;
}

interface action {
  type: string;
  payload: any;
}

const initialState: taskTimeReportListState = {
  loading: false,
  taskTimeDetails: {},
  error: "",
};


export const getTaskTimeReportListReducer = (
  state = initialState,
  action: action
) => {
  switch (action.type) {
    case GET_TASK_TIME_REPORT_LIST_REQUEST:
      return {
        loading: true,
      };
    case GET_TASK_TIME_REPORT_LIST_SUCCESS:
      return {
        loading: false,
        taskTimeDetails: action.payload,
        error: "",
      };
    case GET_TASK_TIME_REPORT_LIST_FAILURE:
      return {
        loading: false,
        taskTimeDetails: {},
        error: action.payload,
      };
    default:
      return state;
  }
};


